'use client';
import React, { useState, useEffect } from 'react';
import { Button } from '@heroui/react';
import { FaAppStore, FaGooglePlay } from 'react-icons/fa'
import Link from 'next/link'
import Image from 'next/image'

const UpgradeApp = ({ children }) => {
  const [isNativeApp, setisNativeApp] = useState(false)
  const [nativeAppVersion, setNativeAppVersion] = useState(1000)
  
  useEffect(() => {
    if (isNativeApp) return
    if (typeof window !== 'undefined') {
      if (window?.isNativeApp) {
        setisNativeApp(true)
        setNativeAppVersion(parseInt(window?.nativeVersion.replace(/\./g, '')))
      }
    }
  }, [isNativeApp, nativeAppVersion])
    
  if (!isNativeApp) return <>{children}</>
  if (nativeAppVersion >= 200) return <>{children}</>

  return (<div className='grow bg-chTan-200 mt-12 mb-20'>
    <div className='px-4'>
        <div className='h-[350px] flex justify-center items-center flex-col'>
        <Image src='/challenge-hound-logo.png' alt='Challenge Hound' width={250} height={88} className='' />
        <div className='text-center mt-6 text-chTan-800'>
            Please upgrade to the latest version of the Challenge Hound app.
            
            <div className='mt-6'>
            {window?.platformOs === 'android' ? 
                <Button 
                as={Link}
                startContent={<FaGooglePlay className='text-2xl' />}
                href='https://play.google.com/store/apps/details?id=com.mobile1.challengehound'
                color='primary'>Play Store</Button> 
                :
                <Button 
                as={Link}
                startContent={<FaAppStore className='text-2xl' />}
                href='https://apps.apple.com/us/app/challenge-hound/id6448111660'
                color='primary'>App Store</Button>
            }
            </div> 
        </div>
        </div>
    </div>
  </div>)
}

export default UpgradeApp;
